import React from 'react';
import { motion } from 'framer-motion';
export function CommunitySection() {
  return <section id="community" className="py-32 px-6 md:px-12 bg-cream" data-id="element-18">
      <div className="max-w-7xl mx-auto" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-20">
          <span className="text-xs font-sans font-bold uppercase tracking-[0.2em] text-marigold mb-4 block" data-id="element-21">
            Community
          </span>
          <h2 className="text-4xl md:text-5xl text-navy mb-4 font-serif tracking-wide" data-id="element-22">
            50 active members and growing.
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="mb-12" data-id="element-23">
          <img src="https://substackcdn.com/image/fetch/w_1200,c_limit,f_auto,q_auto:good,fl_progressive:steep/https%3A%2F%2Fsubstack-post-media.s3.amazonaws.com%2Fpublic%2Fimages%2Fa08a36e2-2661-49e6-afdb-abbbe7a9aa34_4032x3024.jpeg" alt="A warm candid multigenerational gathering of the Familiar Spaces community" className="w-full h-[400px] md:h-[500px] object-cover rounded-xl border border-navy/10" data-id="element-24" />
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-25">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-white p-8 rounded-xl border border-navy/10" data-id="element-26">
            <h3 className="text-xl font-serif tracking-wide text-navy mb-3" data-id="element-27">
              Ages 1 to 79
            </h3>
            <p className="text-navy/70 text-sm leading-relaxed" data-id="element-28">
              A multigenerational community already taking shape in Mexico City.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="bg-white p-8 rounded-xl border border-navy/10" data-id="element-29">
            <h3 className="text-xl font-serif tracking-wide text-navy mb-3" data-id="element-30">
              200+ years of collective experience
            </h3>
            <p className="text-navy/70 text-sm leading-relaxed" data-id="element-31">
              Members bring deep experience across architecture, urbanism,
              design, development, and community building.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="bg-white p-8 rounded-xl border border-navy/10" data-id="element-32">
            <h3 className="text-xl font-serif tracking-wide text-navy mb-3" data-id="element-33">
              Built through real gatherings
            </h3>
            <p className="text-navy/70 text-sm leading-relaxed" data-id="element-34">
              Community meals, conversations, workshops, and visits help people
              feel the model before committing to it.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}